import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Portal from '@spothero/ui/portal';
import Button from '@spothero/ui/button';
import Modal from '@spothero/ui/modal';
import ModalContent from '@spothero/ui/modal-content';
import CancellationInfo from 'common/cancellation-info/CancellationInfo';
import Card from 'common/card/Card';
import SHLoader from 'common/loader/SHLoader';
import PriceDisplay from 'common/airport/PriceDisplay';
import SpotDetailsAirportHero from './header/SpotDetailsAirportHero';
import ImportantInformation from 'common/airport/ImportantInformation';
import AmenitiesCardPanel from './panels/AmenitiesCardPanel';
import HoursCardPanel from './panels/HoursCardPanel';
import PhotosCardPanel from './panels/PhotosCardPanel';
import DirectionsCardPanel from './panels/DirectionsCardPanel';
import ThingsToKnowCardPanel from './panels/ThingsToKnowCardPanel';
import HowToParkCardPanel from './panels/HowToParkCardPanel';
import AirportPurchaseInformation from './purchase/AirportPurchaseInformation';
import SpotImagesDesktop from 'spot-details/details/SpotImagesDesktop';

class SpotDetailsAirportContentOld extends Component {
    static propTypes = {
        isMobile: PropTypes.bool.isRequired,
        currencyType: PropTypes.string,
        isMonthly: PropTypes.bool,
        starts: PropTypes.string,
        ends: PropTypes.string,
        updateSelectedSpot: PropTypes.func,
        updateSearchTimes: PropTypes.func,
        fetchAirportRates: PropTypes.func,
        isLoading: PropTypes.bool,
        pushTo: PropTypes.func,
        isAirportRateUnavailable: PropTypes.bool,
        facility: PropTypes.object,
        selectedRate: PropTypes.object,
        onCheckoutClick: PropTypes.func,
    };
    state = {
        showLocationPhotosModal: false,
    };

    _onPhotoModalToggle = () => {
        this.setState(prevState => {
            return {
                showLocationPhotosModal: !prevState.showLocationPhotosModal,
            };
        });
    };

    render() {
        const {
            isMobile,
            currencyType,
            isMonthly,
            starts,
            ends,
            updateSearchTimes,
            fetchAirportRates,
            isLoading,
            pushTo,
            isAirportRateUnavailable,
            updateSelectedSpot,
            facility,
            selectedRate,
            onCheckoutClick,
        } = this.props;
        const {showLocationPhotosModal} = this.state;
        let cancellationAllowed = true;

        if (facility) {
            cancellationAllowed = facility.cancellation_allowed;
        }

        if (isLoading || !facility) {
            return <SHLoader className="SpotDetailsAirport-loader" />;
        }

        const images = facility.airport.shuttle.images.concat(facility.images);

        return (
            <>
                <div className="SpotDetailsAirport">
                    <SpotDetailsAirportHero facility={facility} />
                    <div className="SpotDetailsAirport-ImportantInformation container">
                        <Card>
                            <ImportantInformation data={facility.airport} />
                        </Card>
                    </div>
                    <div className="SpotDetailsAirport-content container">
                        <div className="SpotDetailsAirport-panels">
                            <AmenitiesCardPanel
                                amenities={facility.amenities_full}
                            />
                            <HoursCardPanel
                                facility={facility}
                                selectedRate={selectedRate}
                            />
                            <PhotosCardPanel
                                images={images}
                                isMobile={isMobile}
                                onPhotoClick={this._onPhotoModalToggle}
                            />
                            <DirectionsCardPanel
                                facility={facility}
                                selectedRate={selectedRate}
                                isMonthly={isMonthly}
                            />
                            <ThingsToKnowCardPanel
                                facility={facility}
                                selectedRate={selectedRate}
                                isMonthly={isMonthly}
                            />
                            <HowToParkCardPanel
                                facility={facility}
                                selectedRate={selectedRate}
                                isMonthly={isMonthly}
                                isOpen={false}
                                collapsible
                            />
                        </div>
                        {isMobile ? (
                            <Portal>
                                <div className="SpotDetailsAirport-snapshot">
                                    <CancellationInfo
                                        className="SpotDetailsAirport-no-cancellation"
                                        cancellationAllowed={
                                            cancellationAllowed
                                        }
                                    />
                                    <div className="SpotDetailsAirport-snapshot-price-container">
                                        <PriceDisplay
                                            currencyType={currencyType}
                                            price={
                                                selectedRate
                                                    ? selectedRate.display_price
                                                    : facility.airport
                                                          .lowest_daily_rate
                                            }
                                            isDefault={!selectedRate}
                                        />
                                        <Button
                                            color="primary"
                                            disabled={!selectedRate}
                                            onClick={onCheckoutClick}
                                        >
                                            Checkout
                                        </Button>
                                    </div>
                                </div>
                            </Portal>
                        ) : (
                            <div className="SpotDetailsAirport-checkout">
                                <AirportPurchaseInformation
                                    onCheckoutClick={onCheckoutClick}
                                    facility={facility}
                                    selectedRate={selectedRate}
                                    starts={starts}
                                    ends={ends}
                                    availableTransientInventory={
                                        facility.available_transient_inventory
                                    }
                                    fetchRates={fetchAirportRates}
                                    updateSearchTimes={updateSearchTimes}
                                    isAirportRateUnavailable={
                                        isAirportRateUnavailable
                                    }
                                    isFetchingRates={isLoading}
                                    pushTo={pushTo}
                                    updateSelectedSpot={updateSelectedSpot}
                                />
                            </div>
                        )}
                    </div>
                </div>
                {showLocationPhotosModal && (
                    <Modal
                        className="SpotDetailsAirportModal"
                        title="Photos"
                        onHidden={this._onPhotoModalToggle}
                    >
                        <ModalContent>
                            <SpotImagesDesktop
                                images={images}
                                showThumbnails={false}
                                width={504}
                                height={412}
                            />
                        </ModalContent>
                    </Modal>
                )}
            </>
        );
    }
}

export default SpotDetailsAirportContentOld;
